import CoachPassesApp from "./CoachPassesApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(CoachPassesApp);
